import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { Core } from "@faire/design-tokens";
import { clearSelectedBrandOrderLocalStorage, setSelectedBrandOrderToLocalStorage } from "@faire/help-center-self-serve/utils/localStorage";
import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken, isRetailer } from "@faire/help-center-utils/serialized-data/getRetailer";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Column, Flex, Grid } from "@faire/web--source/slate/Layout";
import { SearchInput } from "@faire/web--source/slate/SearchInput";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDebouncedValue } from "@faire/web--source/ui/hooks/useDebouncedValue";
import { useState } from "@faire/web--source/ui/hooks/useState";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackCxFoundationsOrderListPageView } from "@faire/web-api--source/events/cxFoundations/view/orderListPage";
import { trackHelpCenterOrderSkipClick } from "@faire/web-api--source/events/helpCenter/click/orderSkip";
import { trackHelpCenterSelfServeOrderSearchKeyboardInput } from "@faire/web-api--source/events/helpCenter/keyboardInput/selfServeOrderSearch";
import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { BackButton } from "../../components/BackButton";
import { OrderItemCard } from "../../components/OrderItemCard";
import { useSelfServeContextStore } from "../../hooks/SelfServeContext";
import { useIssueType } from "../../hooks/useIssueType";
import { useNavigation } from "../../hooks/useNavigation";
import { useOrderItemCardGrid } from "../../hooks/useOrderItemCardGrid";
import { useSearchPaginatedBrandOrders } from "../../hooks/useSearchPaginatedBrandOrders";
import { useTrackPageViewEffect } from "../../hooks/useTrackPageViewEffect";
import { SearchResultNotFound } from "../components/SearchResultNotFound";
import { BrandOrdersLoadingSkeleton } from "./BrandOrdersLoadingSkeleton";
import { NotRelatedToOrderButtonConditionally } from "./NotRelatedToOrderButton";
import { ShowMoreOrdersButton } from "./ShowMoreOrdersButton";
import { SkipButtonConditionally } from "./SkipButton";
import { trackClickOnIssueUnrelatedToOrder } from "./utils";
var SEARCH_DEBOUNCE_TIME = 300;
export var Order = function Order() {
  var _getRetailerToken, _getBrandToken;
  var _useNavigation = useNavigation(),
    goToNextStep = _useNavigation.goToNextStep;
  var _useSelfServeContextS = useSelfServeContextStore([]),
    _useSelfServeContextS2 = _slicedToArray(_useSelfServeContextS, 2),
    setSelfServeContextStore = _useSelfServeContextS2[1];
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    searchText = _useState2[0],
    setSearchText = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    focused = _useState4[0],
    setFocused = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    isUserFirstType = _useState6[0],
    setIsUserFirstType = _useState6[1];
  var debouncedSearchValue = useDebouncedValue(searchText, SEARCH_DEBOUNCE_TIME);
  var _useSearchPaginatedBr = useSearchPaginatedBrandOrders({
      query: debouncedSearchValue
    }),
    _useSearchPaginatedBr2 = _useSearchPaginatedBr.brandOrders,
    brandOrders = _useSearchPaginatedBr2 === void 0 ? [] : _useSearchPaginatedBr2,
    isLoading = _useSearchPaginatedBr.isLoading,
    showMoreOrders = _useSearchPaginatedBr.showMoreOrders,
    hasMoreOrders = _useSearchPaginatedBr.hasMoreOrders;
  useTrackPageViewEffect(trackCxFoundationsOrderListPageView);
  var retailerToken = (_getRetailerToken = getRetailerToken()) !== null && _getRetailerToken !== void 0 ? _getRetailerToken : "";
  var brandToken = (_getBrandToken = getBrandToken()) !== null && _getBrandToken !== void 0 ? _getBrandToken : "";
  var _useIssueType = useIssueType(),
    issueType = _useIssueType.issueType;
  var _useViewport = useViewport(),
    isMobile = _useViewport.isMobile;
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var brandOrdersRef = useRef(null);
  var orderItemCardRef = useRef(null);
  var _useOrderItemCardGrid = useOrderItemCardGrid(),
    gap = _useOrderItemCardGrid.gap,
    itemsPerRow = _useOrderItemCardGrid.itemsPerRow;
  useEffect(function () {
    if (searchText !== "" && isUserFirstType) {
      trackHelpCenterSelfServeOrderSearchKeyboardInput(retailerToken, brandToken, searchText, "true");
      setIsUserFirstType(false);
    }
  }, [searchText, setIsUserFirstType, isUserFirstType, retailerToken, brandToken]);
  var handleSearchInputChange = function handleSearchInputChange(event) {
    setSearchText(event.target.value);
  };
  var handleIssueUnrelatedButtonClick = function handleIssueUnrelatedButtonClick() {
    trackClickOnIssueUnrelatedToOrder();
    clearSelectedBrandOrderLocalStorage();
    setSelfServeContextStore({
      selectedBrandOrder: undefined
    });
    goToNextStep();
  };
  var handleSkipButtonClick = function handleSkipButtonClick() {
    trackHelpCenterOrderSkipClick(retailerToken, brandToken, "", issueType);
    clearSelectedBrandOrderLocalStorage();
    setSelfServeContextStore({
      selectedBrandOrder: undefined
    });
    goToNextStep();
  };
  var handleOrderItemClick = function handleOrderItemClick(brandOrder) {
    setSelfServeContextStore({
      selectedBrandOrder: brandOrder
    });
    setSelectedBrandOrderToLocalStorage(brandOrder);
    goToNextStep({
      brandOrder: brandOrder
    });
  };
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-test-id": "order-select-wrapper"
  }, /*#__PURE__*/React.createElement(BackButton, null), isMobile ? null : /*#__PURE__*/React.createElement(Spacer, {
    height: "3x"
  }), /*#__PURE__*/React.createElement(HeadingWrapper, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "sectionHeaderSansMedium"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "qYhHlL",
    defaultMessage: "Is this related to a specific order?"
  })), /*#__PURE__*/React.createElement(SkipButtonConditionally, {
    onClick: handleSkipButtonClick
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "3x"
  }), /*#__PURE__*/React.createElement(OrderSearchInput, {
    width: "100%",
    value: searchText,
    onChange: handleSearchInputChange,
    onClear: function onClear() {
      return setSearchText("");
    },
    onFocus: function onFocus() {
      return setFocused(true);
    },
    onBlur: function onBlur() {
      return setFocused(false);
    },
    placeholder: isRetailer() ? strictLocalize({
      id: "198YwS",
      defaultMessage: "Search by brand or order number"
    }) : strictLocalize({
      id: "aCaGnZ",
      defaultMessage: "Search by customer or order number"
    })
  }), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(Grid, {
    ref: brandOrdersRef,
    gap: gap,
    columns: itemsPerRow,
    style: {
      width: "100%"
    },
    columnTemplate: function columnTemplate(columns) {
      return isMobile ? "repeat(".concat(columns, ", minmax(150px, 1fr))") : "repeat(".concat(columns, ", 1fr)");
    }
  }, brandOrders.map(function (brandOrder, index) {
    return /*#__PURE__*/React.createElement(OrderItemCard, _objectSpread(_objectSpread({
      innerRef: orderItemCardRef,
      key: index
    }, brandOrder), {}, {
      isRetailer: isRetailer(),
      onClick: function onClick() {
        return handleOrderItemClick(brandOrder);
      }
    }));
  }), /*#__PURE__*/React.createElement(NotRelatedToOrderButtonConditionally, {
    brandOrders: brandOrders,
    focused: focused,
    searchText: searchText,
    onClick: handleIssueUnrelatedButtonClick
  })), brandOrders.length === 0 && !isLoading ? (/*#__PURE__*/React.createElement(SearchResultNotFound, {
    width: "100%",
    searchWord: searchText,
    clearSearch: function clearSearch() {
      return setSearchText("");
    }
  })) : null, /*#__PURE__*/React.createElement(BrandOrdersLoadingSkeleton, {
    isLoading: isLoading
  }), /*#__PURE__*/React.createElement(Spacer, {
    height: "3x"
  }), /*#__PURE__*/React.createElement(ShowMoreOrdersButton, {
    visibleWhen: hasMoreOrders(),
    onClick: showMoreOrders
  }));
};
var HeadingWrapper = styled(Flex).attrs({
  direction: {
    tabletAndAbove: "row",
    mobileAndAbove: "column"
  },
  justify: {
    tabletAndAbove: "space-between",
    mobileAndAbove: "flex-start"
  },
  align: "center"
}).withConfig({
  displayName: "Order__HeadingWrapper"
})(["width:100%;"]);
var Wrapper = styled(Column).attrs({
  align: "flex-start"
}).withConfig({
  displayName: "Order__Wrapper"
})(["background-color:", ";padding:", ";", "{padding:", ";}"], Core.surface.inverse, getSpacing("4x", "3x", "4x", "5x"), responsiveMediaQueries.mobile, getSpacing("2x"));
var OrderSearchInput = styled(SearchInput).withConfig({
  displayName: "Order__OrderSearchInput"
})(["width:", ";", "{width:100%;}"], function (props) {
  var _props$width;
  return (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : "100%";
}, responsiveMediaQueries.mobile);